import Button from "../components/atoms/Button";
import Cards from "../components/organisms/Cards";
import Testimonials from "../components/organisms/Testimonials";
import FlexSection from "../components/organisms/FlexSection";
import Benefits from "../components/organisms/Benefits";
import BenefitsCard from "../components/organisms/BenefitsCard";
import FormSelector from "../components/organisms/FormSelector";
import BlogSection from "../components/organisms/BlogSection";
import Steps from "../components/molecules/Steps";
import Faqs from "../components/molecules/Faqs";
import HeroIndexed from "../components/organisms/HeroIndexed";

const components = {
  Button: Button,
  Cards: Cards,
  Testimonials: Testimonials,
  FlexSection: FlexSection,
  Benefits: Benefits,
  BenefitsCard: BenefitsCard,
  FormSelector: FormSelector,
  BlogSection: BlogSection,
  Steps: Steps,
  Faqs: Faqs,
  HeroIndexed: HeroIndexed,
};

export default components;
